import styled from 'styled-components';

export const StyledErrorPage = styled.main`
  min-height: 100vh;
  background: ${props => props.theme.colors.background.base};
`;

export const ErrorWrapper = styled.div`
  margin: ${props => props.theme.spacing(16, 0, 42)};
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const HeadingContainer = styled.div`
  margin-top: ${props => props.theme.spacing(12)};
`;

export const Paragraph = styled.p`
  ${props => props.theme.typography.body}
  max-width: 336px;
  margin: ${props => props.theme.spacing(5, 0, 8)};
  @media ${props => props.theme.tablet} {
    max-width: 512px;
  }
`;
